
      <div class="block md:hidden">
        <a id="nav-icon" (click)="openCloseMobileMenu()" style="display:block;width: 35px;height: 35px;" [ngClass]="showMobileMenu ? 'open' :''">
          <span  style="display: block"></span>
          <span style="display: block"></span>
          <span style="display: block"></span>
        </a>

        <app-slider-side-menu [isShow]="showMobileMenu"  #sliderSideMenu >
          <div class="menu menu-mobile z-40">
            <div class="user-info text-center text-normal">
              <app-image-wrapper [avatar]="avatarUrl" [fontSize]="40" [class]="'menu-mobile-main-avatar'" (click)='myProfil()'></app-image-wrapper>
              <div class="name mt-1-0">{{nickname}}</div>
              <div class="border-top-style ">
                <div class="grid grid-cols-2">
                  <div class="text-center border-left-pink">
                    {{balance | currency : currency: 'Դ'}}
                  </div>
                  <div class="text-center">
                    {{tickets}}  <app-ticket></app-ticket>
                  </div>
                </div>
              </div>
            </div>

            <a (click)="onClose()"  [routerLink]="['/']" class="mobile-menu-link">{{'home'| translate}}</a>
<!--            <a (click)="onClose()"  [routerLink]="['/my-teams']" class="mobile-menu-link">{{'my_teams'| translate}}</a>-->
            <a *ngIf="showMyPublishersHref" (click)="onClose()"  [routerLink]="['/publishers/my-publisher']" class="mobile-menu-link">{{'my_publishers'| translate}}</a>
            <a (click)="onClose()"  [routerLink]="['/publishers']" class="mobile-menu-link">{{'publishers'| translate}}</a>
<!--            <a (click)="onClose()"  [routerLink]="['/teams']" class="mobile-menu-link">{{'teams'| translate}}</a>-->
            <a (click)="onClose()"  [routerLink]="['/me/topup']" class="mobile-menu-link">{{'topup'| translate}}</a>
            <a (click)="onClose()"  [routerLink]="['/me/withdraw']" class="mobile-menu-link">{{'withdraw'| translate}}</a>
            <a (click)="onClose()"  [routerLink]="['/me/transactions']" class="mobile-menu-link">{{'transactions'| translate}}</a>

            <a (click)="onClose()"  [routerLink]="['/ai']" class="mobile-menu-link">{{'AI'| translate}}</a>

            <a (click)="onClose()"  [routerLink]="['/me/settings']" class="mobile-menu-link">{{'settings'| translate}}</a>

            <a (click)="onClose()" [routerLink]="['/me/edit-profile']" class="mobile-menu-link">{{'edit_profile'| translate}}</a>
            <a (click)="onClose()"  [routerLink]="['/me/edit-password']" class="mobile-menu-link">{{'change_password'| translate}}</a>
            <a (click)="onClose()"  [routerLink]="['/me/tournaments']" class="mobile-menu-link">{{'participated_tournaments'| translate}}</a>
            <a (click)="onClose()"  [routerLink]="['/me/referrals']" class="mobile-menu-link">{{'referrals'| translate}}</a>
            <a (click)="toggleSound()"  class="mobile-menu-link">
              <i [ngClass]=" (!this.soundEnabled) ? 'fa fa-volume-mute' : 'fa fa-volume'"></i>
              <span> {{(this.soundEnabled) ? ('mute' | translate) : ('unmute'| translate)}}</span>
            </a>
            <a (click)="logOut()" style="color:red;cursor: pointer" class="mobile-menu-link">{{'log_out'| translate}}</a>
            <hr/>
            <a href="https://blog.cybfed.com/detail/privacy-policy" class="mobile-menu-link">{{'privacy_and_policy' | translate}}</a>
            <a href="https://blog.cybfed.com/detail/terms-and-conditions" class="mobile-menu-link">{{'terms_and_conditions' | translate}}</a>
            <a href="" class="mobile-menu-link">{{'news' | translate}}</a>
            <a href="" class="mobile-menu-link">{{'contact_us' | translate}}</a>
            <hr/>
            <div class="mobile-footer">
              <app-language-changer forPlace="footer"></app-language-changer>
            </div>
            <hr/>
            <div class="footer-component-footer">
              © CYBFED 2024, {{'all_rights_reserved' | translate}}
            </div>
          </div>
        </app-slider-side-menu>
      </div>
      <div class="md:block hidden">
        <app-dropdown>
          <div class="dropdown-button">
            <div class="w-36 ml-2 flex text-normal justify-end gap-x-1 cursor-pointer" (click)="onOpenWidget()">
              <div>
                <app-image-wrapper [avatar]="avatarUrl" [class]="'rounded-full w-8 h-8 mt-1 m-auto'"></app-image-wrapper>
              </div>
              <div class=" text-xs py-1">
                <div class="name md:block hidden overflow-ellipsis">{{nickname}}</div>
                <div class="name md:block hidden">{{balance | currency: currency}}</div>
                <div class="name md:block hidden">{{tickets + ' T'}}</div>
              </div>
              <i class="fa fa-caret-down mt-4"></i>
            </div>
          </div>
          <div class="dropdown-options">
            <div class="absolute text-normal -left-36 top-full z-10 mt-3 w-60 overflow-hidden rounded-3xl bg-input shadow-lg ring-1 ring-gray-900/5">
              <div>
                <ng-container *ngIf="!pubBool">
                  <a [routerLink]="'/players/'+ authUser.userId" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                    <div class="flex  h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">
                      <i class="fa fa-user"></i>
                    </div>
                    <div class="flex-auto">
                      <div class="block font-semibold text-normal">
                        {{'my_profile'| translate}}
                      </div>
                    </div>
                  </a>
<!--                  <a [routerLink]="'/my-teams'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">-->
<!--                    <div class="flex  h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">-->
<!--                      <i class="fa fa-users"></i>-->
<!--                    </div>-->
<!--                    <div class="flex-auto">-->
<!--                      <div class="block font-semibold text-normal">-->
<!--                        <span>{{'my_teams'| translate}}</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </a>-->
                  <a [routerLink]="'/organizations/my-publisher'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                    <div class="flex  h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">
                      <i class="fa fa-object-group"></i>
                    </div>
                    <div class="flex-auto">
                      <div class="block font-semibold text-normal">
                        <span>{{'my_publishers'| translate}}</span>
                      </div>
                    </div>
                  </a>
                  <a [routerLink]="'/marketplace/manage/dashboard'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                    <div class="flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">
                      <i class="fa fa-shopping-cart"></i>
                    </div>
                    <div class="flex-auto">
                      <div class="block font-semibold text-normal">
                        <span>{{'My Store'| translate}}</span>
                      </div>
                    </div>
                  </a>
                  <a [routerLink]="'/me/transactions'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                    <div class="flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">
                      <i class="fa fa-money-bill"></i>
                    </div>
                    <div class="flex-auto">
                      <div class="block font-semibold text-normal">
                        <span>{{'balance'| translate}}</span>
                      </div>
                    </div>
                  </a>
                  <a [routerLink]="'/me/settings'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                    <div class="flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">
                      <i class="fa fa-cogs"></i>
                    </div>
                    <div class="flex-auto">
                      <div class="block font-semibold text-normal">
                        <span>{{'settings'| translate}}</span>
                      </div>
                    </div>
                  </a>
                    <a [routerLink]="'/me/referrals'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                        <div class="flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">
                            <i class="fa fa-cogs"></i>
                        </div>
                        <div class="flex-auto">
                            <div class="block font-semibold text-normal">
                                <span>{{'referrals'| translate}}</span>
                            </div>
                        </div>
                    </a>

                  <a  (click)="logOut()" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                    <div class="flex  h-8 w-8 flex-none items-center justify-center rounded-lg bg-dark">
                      <i class="fa fa-sign-out"></i>
                    </div>
                    <div class="flex-auto">
                      <div class="block font-semibold text-normal">
                        <span>{{'logout'| translate}}</span>
                      </div>
                    </div>
                  </a>
                </ng-container>

                <ng-container *ngIf="pubBool">
                  <app-navigate-accounts (close)="closeWidg($event)" (prev)='changePubSection($event)' (navigateTo) = "navigateToPublisher($event)"></app-navigate-accounts>
                </ng-container>
                <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-card">
                  <a (click)="toggleSound()"  class="flex   items-center justify-center text-normal gap-x-2.5 p-3 text-sm font-semibold leading-6 hover:bg-card-hover">
                    <i [ngClass]=" (!this.soundEnabled) ? 'fa fa-volume-up' : 'fa fa-volume-off'"></i>
                    <span> {{(this.soundEnabled) ? ('mute' | translate) : ('unmute'| translate)}}</span>
                  </a>
                  <a  (click)="getClans($event)" class="flex items-center justify-center text-normal gap-x-2.5 p-3 text-sm font-semibold leading-6 hover:bg-card-hover">
                    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path fill="currentColor" d="M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8c-5.9 16.7-24.2 25.4-40.8 19.5s-25.4-24.2-19.5-40.8C55.6 150.7 73.2 122 97.6 97.6c87.2-87.2 228.3-87.5 315.8-1L455 55c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 128c0 13.3-10.7 24-24 24l-8.4 0c0 0 0 0 0 0L344 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l41.1-41.1c-62.6-61.5-163.1-61.2-225.3 1zM16 312c0-13.3 10.7-24 24-24l7.6 0 .7 0L168 288c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6 0-.7 0-7.6z"/>
                    </svg>
                    <span>{{'Switch'| translate}}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </app-dropdown>
      </div>


